// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"ed80369cb8ab65c2","9651":"11d6ff1e90a0305b"}[chunkId] + ".js";
};